import { ChevronLeft, ChevronRight } from "lucide-react";

export const PaginationBar = ({ page, pages, total, pageSize, onPage }) => {
  if (!total) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="flex flex-col items-center justify-between gap-3 border-t border-[#e8edf5] px-4 py-3 sm:flex-row sm:px-5" data-testid="pagination">
      <span className="text-xs text-[#5b667a] sm:text-sm" data-testid="pagination-info">
        Mostrando {from}–{to} de {total.toLocaleString("es-MX")} clientes
      </span>
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => onPage(page - 1)} disabled={page <= 1} className="tr-btn-light px-3 py-2 text-sm" data-testid="pagination-prev">
          <ChevronLeft className="h-4 w-4" /> Anterior
        </button>
        <span className="px-1 text-sm font-semibold text-[#182235]" data-testid="pagination-page">
          Página {page} de {pages}
        </span>
        <button type="button" onClick={() => onPage(page + 1)} disabled={page >= pages} className="tr-btn-light px-3 py-2 text-sm" data-testid="pagination-next">
          Siguiente <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
